import { apiPost, apiPostBlob, type BlobResponse } from '../client';
import { LONG_TIMEOUT_MS } from '../../config/env';
import type {
  LogDetailResponse,
  LogFilters,
  LogListResponse,
  ReportIssueRequest,
  ReportSystemIssueRequest,
} from '../types/logs';
import type { ResponseBase } from '../types/common';

/** Filtered log list (`Logs/Index`, backend Faz E). */
export function getLogs(filters: LogFilters): Promise<LogListResponse> {
  return apiPost<LogFilters, LogListResponse>('Logs/Index', filters, { timeoutMs: LONG_TIMEOUT_MS });
}

/** One session's full request/response log (`Logs/Detail`). */
export function getLogDetail(sessionId: string): Promise<LogDetailResponse> {
  return apiPost<{ sessionId: string }, LogDetailResponse>('Logs/Detail', { sessionId });
}

/** Export the filtered log set (`Logs/Download` → `HttpResponseMessage`). */
export function downloadLogs(filters: LogFilters): Promise<BlobResponse> {
  return apiPostBlob<LogFilters & { format: string }>(
    'Logs/Download',
    { ...filters, format: 'json' },
    { timeoutMs: LONG_TIMEOUT_MS }
  );
}

/** File an issue against a specific log session (`Logs/ReportIssue`). */
export function reportIssue(body: ReportIssueRequest): Promise<ResponseBase> {
  return apiPost<ReportIssueRequest, ResponseBase>('Logs/ReportIssue', body);
}

/** Client-side error/screenshot capture (`Logs/ReportSystemIssue`, `[AllowAnonymous]` —
 *  bare body, no session header). Fire-and-forget from the global error hook — callers
 *  should swallow rejections. */
export function reportSystemIssue(body: ReportSystemIssueRequest): Promise<ResponseBase> {
  return apiPost<ReportSystemIssueRequest, ResponseBase>('Logs/ReportSystemIssue', body, {
    skipSession: true,
  });
}
